import React, { lazy } from 'react'
const CheckoutWizard = lazy(() => import('./pages/CheckoutWizard'))
const GeneralConfirmationPage = lazy(() => import('./pages/GeneralConfirmationPage'))
const CustomerSupportPage = lazy(() => import('./pages/CustomerSupportPage'))

const CheckoutRouting = [
  // main checkout
  {
    element: <CheckoutWizard />,
    path: 'checkout',
    public: true,
  },
  {
    element: <GeneralConfirmationPage />,
    path: 'booking/:orderID',
    public: true,
  },
  {
    element: <CustomerSupportPage />,
    path: 'confirmation/:quickOrderID',
    public: true,
  },
]

export default CheckoutRouting
